
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/corporatiu/premsa/tv3",
      function () {
        return require("private-next-pages/corporatiu/premsa/tv3/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/corporatiu/premsa/tv3"])
      });
    }
  